import { X, XIcon } from "lucide-react";
import React from "react";

interface AlertProps {
  className?: string;
  type?: "success" | "error" | "info" | "warning";
  message: string;
}

const Alert: React.FC<AlertProps> = ({
  className = "",
  type = "info",
  message,
}) => {
  const colorMap = {
    success: "green",
    error: "red",
    info: "blue",
    warning: "yellow",
  };
  return (
    <div
      className={`flex items-center bg-${colorMap[type]}-100 text-${colorMap[type]}-800 border border-${colorMap[type]}-300 rounded-md p-4 ${className}`}
    >
      <div className="flex-1">{message}</div>

      <button className={`p-2 hover:bg-${colorMap[type]}-200 rounded-full`}>
        <XIcon className="w-4 h-4 text-gray-500 hover:text-gray-700" />
      </button>
    </div>
  );
};

export default Alert;
